<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-button
              @click="isShowCreatePopup()"
              class="bg_l_green"
              icon-pack="feather"
              icon="icon-plus"
              v-has-permission="permission291"
            >
              {{ $t("CreateNewOperator") }}
            </vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :columns="[
                { title: $t('Firstname') },
                { title: $t('Lastname') },
                { title: $t('nickName') },
                { title: $t('MobileNumber'), forMob: 'mobileNumber' },
                { title: $t('driverLicenseNumber') },
                { title: $t('CreateOn') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 18%">
                  {{ row.firstName ? row.firstName : "---" }}
                </td>
                <td style="width: 18%">
                  {{ row.lastName ? row.lastName : "---" }}
                </td>
                <td style="width: 18%">
                  {{ row.nickName ? row.nickName : "---" }}
                </td>
                <td style="width: 18%">{{ row.mobileNumber }}</td>
                <td style="width: 14%">{{ row.driverLicenseNumber }}</td>
                <td style="width: 14%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <create-popup
          :show="onShowCreatePopup"
          @finish="onfinish"
          @close="closeCreatePopup"
        ></create-popup>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";

export default {
  name: "shipping-Operators",
  components: {
    DataGrid,
    CreatePopup,
  },
  data() {
    return {
      permission291: "CreateOperator",
      onShowCreatePopup: false,
      gridDataSource: {
        type: "app",
        service: "Shipping/api/OperatorsQuery",
      },
    };
  },
  methods: {
    isShowCreatePopup() {
      this.onShowCreatePopup = true;
    },
    closeCreatePopup() {
      this.onShowCreatePopup = false;
    },
    onfinish() {
      this.closeCreatePopup();
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
  },
};
</script>
